import factory from './icon';
import Svg from './glyphs/minus.svg';

export default factory(Svg);
